import axios from "axios";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

const paymentMethodPayload = (values = {}, fields) => fields.reduce((payload, field) => {
  if (values[field] !== undefined && values[field] !== null && values[field] !== "") {
    payload[field] = values[field];
  }
  return payload;
}, {});

const create = (values) => {
    const action = "afterlogin/creditcard/createPaymentMethod";
    const data = paymentMethodPayload(values, ["client_id", "stripe_payment_method_id"]);
    return axios.post(API_URL + action, data, { headers: authHeader() });
  };

  const update = (values) => {
    const action = "afterlogin/creditcard/updatePaymentMethod";
    const data = paymentMethodPayload(values, ["client_id", "stripe_payment_method_id", "exp_month", "exp_year"]);
    return axios.post(API_URL + action, data, { headers: authHeader() });
  };
  
const view = (values) => {
  const action = `afterlogin/creditcard/getPaymentMethod`;
  
  const data = paymentMethodPayload(values, ["client_id"]);
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const list = (values) => {
  const action = "afterlogin/creditcard/listClientPaymentMethods";
  const data = paymentMethodPayload(values, ["client_id"]);
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const reconcileSubscriptionCards = (values) => axios.post(API_URL + "afterlogin/creditcard/reconcileSubscriptionCards", paymentMethodPayload(values, ["client_id"]), { headers: authHeader() });

const startSetup = (values) => {
  const action = "afterlogin/creditcard/createSetupIntent";
  const data = paymentMethodPayload(values, ["client_id"]);
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const confirmSetup = (values) => {
  const action = "afterlogin/creditcard/confirmSetupIntent";
  const data = paymentMethodPayload(values, ["client_id", "setup_intent_id"]);
  return axios.post(API_URL + action, data, { headers: authHeader() });
};


// const deleted = (values) => {
//     const auth = store.getState().auth;
//     const auth_key = auth.user.auth_key;
//     const action = `afterlogin/creditcard/delete/${values.id}`;
//     const data = {
//       auth_key: auth_key,
//       action: action,
//     };
//     return axios.post(API_URL + action, data, { headers: authHeader() });
//   };

const creditcardupdateApiController = {
    create,
    update,
    view,
    list,
    reconcileSubscriptionCards,
    startSetup,
    confirmSetup,
    // deleted,
  };

export default creditcardupdateApiController;
